
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "./useAuth";
import menuLogo from "../assets/imagens/pentalobe.png";

const ProtectedRoute = ({ element: Component, requiredRole, ...rest }) => {
    const { user, loading, error } = useAuth();
    const location = useLocation(); // Captura a rota atual
    console.log({ loading, error, user, requiredRole }, 'DEBUG: ProtectedRoute');
    if (loading) {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: '100vh', flexDirection: 'column' }} // flexDirection: 'column' para empilhar se precisar de texto abaixo
            >
                <img
                    src={menuLogo}
                    alt="Pentalobe Logo"
                    style={{ maxWidth: '200px', height: 'auto', marginBottom: '20px' }} // Adicione um estilo para controlar o tamanho da imagem e uma margem inferior
                />
                {/* Opcional: Adicione um texto ou spinner de carregamento abaixo da logo */}
                <p style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '600', fontSize: '1.3em' }}>Carregando...</p>
            </div>
        );
    }
    if (error) {
        console.warn('Redirecionando por erro:', error);
        return <Navigate to="/login" state={{ from: location }} />;
    }
    if (user) {
        console.log('Usuário autenticado:', user);
        if (!requiredRole || user.profile === requiredRole) {
            return <Component {...rest} />;
        } else {
            console.warn('Perfil não autorizado:', user.profile);
        }
    } else {
        console.warn('Usuário não autenticado');
    }

   /* if (user && (!requiredRole || user.profile === requiredRole)) {
        return <Component {...rest} />; // Renderiza o componente se o usuário estiver autenticado e autorizado
    }*/

    return <Navigate to="/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;
